import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { PipesModule } from '../pipes/pipes.module';
import { VendorsModule } from '../modules/vendors.module';
import { FormsModule } from '@angular/forms';

// Aide
import { AideService } from '../aide/aide.service';
import { AideComponent } from '../aide/aide.component';
import { AideEditComponent } from '../aide/aide-edit.component';

@NgModule({
  declarations: [
    AideEditComponent,
    AideComponent
  ],
  imports: [
    CommonModule,
    PopoverModule.forRoot(),
    PipesModule,
    FormsModule,
    VendorsModule
  ],
  exports: [
    AideComponent,
    AideEditComponent
  ],
  providers: [
    AideService
  ]
})
export class AideModule {}
